module.exports = __webpack_public_path__ + "templates/display-address.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/display-address/display-address.component.html
// module id = j/jZ
// module chunks = 1